module.exports = __webpack_public_path__ + "img/9-1_Create_Causal_Graph_Flow.5d8443b2.png";